import { render, staticRenderFns } from "./app_download.vue?vue&type=template&id=3e135674&scoped=true&"
import script from "./app_download.vue?vue&type=script&lang=js&"
export * from "./app_download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e135674",
  null
  
)

export default component.exports